import $ from 'jquery';
import _ from 'underscore';
import state from '@bingads-webui-component-legacy/state/index';
import { convertToOData } from '@bingads-webui/filter-entity';

const getDateRange = () => {
  try {
    let dateRange = state.get('$daterange');
    let startdate = (dateRange.start || dateRange.RangeStartDate).toISOString();
    let enddate = (dateRange.end || dateRange.RangeEndDate).toISOString();

    return `startdate=${startdate}&enddate=${enddate}`;
  } catch (e) {
    return '';
  }
};

const getSelectedIds = (projection) => {
  if (!projection) {
    return [];
  }

  if (!_.isUndefined(projection.selectedIds)) {
    return projection.selectedIds;
  }
  if (_.isFunction(projection.get)) {
    //TODO: process select all page
    return projection.get('row.check.list');
  }

  return [];
};

const getQueryStringRaw = (projection) => {
  let dateRange = getDateRange();
  let query = '';
  let selectedIds = getSelectedIds(projection);

  if (_.isEmpty(projection)) {
    return dateRange;
  }

  if (projection.isSelectAll || _.size(selectedIds) === 0) { //check selectedIds size only for compatible original logic
    let projectionFilters = '';

    if (!_.isUndefined(projection.filters)) {
      projectionFilters = projection.filters;
    } else if (_.isFunction(projection.get)) {
      projectionFilters = projection.get('filter');
    }

    let filters = convertToOData(projectionFilters, _.defaults({}, projection.filterOptions));

    query = `$filter=${encodeURIComponent(filters)}`;
  } else if (_.size(selectedIds) > 0) {  //select some ids will distinguish it when new grid support select cross page
    let idFilters = _.map(selectedIds, (id) => {
      return `Id eq ${id}`;
    }).join(' or ');

    query = $.param({$filter: `(${idFilters})`});
  }

  return `${query}&${dateRange}`;
};

const getQueryString = (projection) => {
  const queryString = getQueryStringRaw(projection);

  if (_.isFunction(projection.queryStringProcess)) {
    return projection.queryStringProcess(queryString);
  }
  return queryString;
};

const getSelection = (projection, campaignId = null, adgroupId = null) => {
  return {
    QueryString: getQueryString(projection),
    CampaignId: campaignId,
    AdGroupId: adgroupId,
  };
};

const getDescription = (projection) => {
  let description = {
    idsCount: _.size(getSelectedIds(projection)),
  };

  return JSON.stringify(description);
};

export default (projection, batchActions, entity, campaignId, adgroupId, preview) => {
  const params =  {
    BatchAction: batchActions,
    Description: getDescription(projection),
    Entity: entity,
    Selection: getSelection(projection, campaignId, adgroupId),
  };

  if (preview) {
    return _.extend({
      PreviewEntityIds: getSelectedIds(projection),
    }, params);
  }
  return params;
};
